import * as Sentry from '@sentry/react'

import { getCurrentUser } from './cognito'

export let feedback = Sentry.feedbackIntegration({
  colorScheme: 'light',
  autoInject: false,
  showBranding: false,
  isNameRequired: false,
  formTitle: 'Feedback',
  showEmail: false,
  showName: false,
  buttonLabel: 'Send Feedback',
  submitButtonLabel: 'Send Feedback',
  messagePlaceholder: 'What happened? What did you expect to happen?',
  useSentryUser: {
    name: 'name',
    email: 'email'
  }
})

export function init (): void {
  Sentry.init({
    enabled: process.env.NODE_ENV === 'production',
    dsn: window.constants.SENTRY?.dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        unblock: [
          '.sentry-unblock',
          '[data-sentry-unblock]'
        ],
        unmask: [
          '.sentry-unmask',
          '[data-sentry-unmask]'
        ]
      }),
      feedback
    ],
    environment: window.constants.SENTRY?.environment,
    release: window.constants.COMMIT?.substring(0, 7),
    tracesSampleRate: window.constants.SENTRY?.tracesSampleRate ?? 0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,

    beforeSend (event) {
      if (!event.exception) {
        return event
      }

      if (window.constants.SENTRY?.environment === 'prod') {
        return event
      }

      let user = getCurrentUser()
      let payload = user?.signInUserSession?.idToken?.payload
      let email = payload?.email?.toLowerCase()?.trim()

      let name = [
        payload?.given_name?.trim(),
        payload?.family_name?.trim()
      ]
        .filter(Boolean)
        .join(' ')

      Sentry.showReportDialog({
        eventId: event.event_id,
        user: {
          email,
          name
        }
      })

      return event
    }
  })
}

export async function close (timeout?: number): Promise<void> {
  await Sentry.close(timeout)
}
